export class TimesheetSelectedCells
{
    startRow: number;
    endRow: number;
    startColumn: number;
    endColumn: number;

    isSingleCell()
    {
        return this.startRow === this.endRow && this.startColumn === this.endColumn;
    }
}
